import defineComponent from 'flight';

function SiteHeaderProfile() {
    this.defaultAttrs({
        cartLink: '[data-site-header-profile-cart]'
    });

    this._updateCart = function (evt, payload) {
        let cartLink = this.select('cartLink');
        let itemQuantity = payload.quantityCount;
        let itemTotalSum = payload.sum;
        let itemText;

        if (itemQuantity === 0) {
            itemText = cartLink.data('site-header-profile-cart-text-noitems');
        } else {
            itemText = this._formatString(cartLink.data('site-header-profile-cart-text-hasitems'), itemQuantity, itemTotalSum);
        }

        cartLink.html(itemText);
    };

    this._formatString = function (format) {
        if (format) {
            let args = Array.prototype.slice.call(arguments, 1);
            return format.replace(/{(\d+)}/g, function (match, number) {
                return typeof args[number] !== 'undefined' ? args[number] : match;
            });
        }
    };

    this.after('initialize', function () {
        this.on(document, 'data:cart:after-get-summary', this._updateCart);
    });

}

export default defineComponent.component(SiteHeaderProfile);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/site-header-profile.js